module.exports = __webpack_public_path__ + "static/media/estate-clarity-mockup-4.d3531677.jpg";